import type { BirthDateChangeCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikForm,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

const validateKey = typeUtils.createValidator<BirthDateChangeCommandData>()

export const BirthDateChangeCommandDataForm = (
  props: CommandDataFormProps<BirthDateChangeCommandData>,
) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const informationSources = useHook('pages.crm.useCrmInformationSources')()

  return (
    <FormikForm
      initialValues={{
        _type: 'BirthDateChangeCommandData',
      }}
      {...props}
    >
      <FormikDatePicker
        name={validateKey('birthDateValueDate')}
        label={translate('birthdateChangeButton.birthDateValueDate')}
      />
      <FormikSelect
        name={validateKey('informationSource')}
        label={translate('card.field.informationSource')}
        options={informationSources}
        renderFn={(x) => translateEnum('legalEntity.enum.InformationSource', x)}
      />
      <FormikDatePicker
        name={validateKey('birthDate')}
        label={translate('birthdateChangeButton.birthDate')}
      />
    </FormikForm>
  )
}
